"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectReadReceiptOption')(function selectReadReceiptOption(choice, state) {
    var optionState = state.optionState;
    optionState.readReceiptResponse = choice;
}));
//# sourceMappingURL=selectReadReceiptOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-read-receipts-option/lib/actions/selectReadReceiptOption.js
// module id = 5062
// module chunks = 2